exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.dataview .title[data-v-2ecbe9c2]{font-size:14px;margin-bottom:10px;color:#333;font-weight:bold;padding-left:10px;border-left:3px solid #409eff\n}\n", "", {"version":3,"sources":["/tentcoo/jenkins/workspace/epm-prod-deploy-web-pc/src/views/layout/Dataview.vue"],"names":[],"mappings":";AACA,kCAAkC,eAAe,mBAAmB,WAAW,iBAAiB,kBAAkB,6BAA6B;CAC9I","file":"Dataview.vue","sourcesContent":["\n.dataview .title[data-v-2ecbe9c2]{font-size:14px;margin-bottom:10px;color:#333;font-weight:bold;padding-left:10px;border-left:3px solid #409eff\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-2ecbe9c2","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/dist/cjs.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/layout/Dataview.vue
// module id = UJ8x
// module chunks = 6